import { hasActiveSubscription, isSubscriptionInactive } from '../../../../Model/index.js'
import type { IOrderWithCounts, IUser } from '../../../../Model/index.js'
import { parseTier } from '../../../../Util/billing.js'

export const DASHBOARD_WIDGET_CLASS = 'rounded-xl border border-slate-200 bg-white p-6 shadow-sm'

export const getOrderTimestamp = (value: {
  orderCreated?: string
  draftCreatedAt?: string
  orderSubmission?: string
}) => {
  const candidate = value.orderCreated ?? value.draftCreatedAt ?? value.orderSubmission
  return candidate ? new Date(candidate).getTime() : 0
}

export const getRecentOrders = (orders: IOrderWithCounts[] | undefined) => {
  if (!orders) return []
  return [...orders].sort((a, b) => getOrderTimestamp(b.order) - getOrderTimestamp(a.order)).slice(0, 5)
}

export const planLabel = (planId?: string) => {
  if (!planId) return 'No plan'
  const tier = parseTier(planId)
  return tier.charAt(0).toUpperCase() + tier.slice(1)
}

export const subscriptionState = (user: IUser) => {
  if (user.org.isBillingMissing) return { label: 'Billing incomplete', className: 'badge-error' }
  if (hasActiveSubscription(user.org)) return { label: 'Active', className: 'badge-success' }
  if (isSubscriptionInactive(user.org)) return { label: 'Inactive', className: 'badge-warning' }
  return { label: 'Not configured', className: 'badge-ghost' }
}
